import LTR from "@brand-icons/ploomg4/device-pen/device-pen-ltr.svg";
import RTL from "@brand-icons/ploomg4/device-pen/device-pen-rtl.svg";

import { iconFactory } from "../iconFactory";

export const DevicePenIcon = iconFactory("DevicePenIcon", LTR, RTL);
